import Modal from './modal'

interface PwaInstallModalProps {
	open: boolean
	onOpenChange: (open: boolean) => void
}

export default function PwaInstallModal(props: PwaInstallModalProps) {
	return (
		<Modal
			open={props.open}
			onOpenChange={props.onOpenChange}
		>
			<div className="space-y-6">
				<h1 className="scroll-m-20 text-4xl font-bold tracking-tight">Add to Home Screen</h1>

				<p>Install hangaround.live for the best experience and to enable notifications.</p>
				<div>
					<h3 className="font-semibold mb-2 text-base">iOS - Safari Required</h3>
					<p className="text-sm mb-2 text-gray-600">You must use Safari browser on iOS to add to home screen.</p>
					<ol className="list-decimal list-inside space-y-1 text-sm">
						<li>Open hangaround.live in Safari</li>
						<li>Tap the Share button (square with arrow up) in the toolbar</li>
						<li>Scroll down and tap "Add to Home Screen"</li>
						<li>Tap "Add" in the top right corner</li>
					</ol>
				</div>

				<div>
					<h3 className="font-semibold mb-2 text-base">Android (Chrome)</h3>
					<ol className="list-decimal list-inside space-y-1 text-sm">
						<li>Tap the menu button (three dots) in the top right</li>
						<li>Tap "Add to Home Screen" or "Install app"</li>
						<li>Tap "Add" or "Install" to confirm</li>
					</ol>
				</div>

				<div>
					<h3 className="font-semibold mb-2 text-base">Desktop (Chrome/Edge)</h3>
					<ol className="list-decimal list-inside space-y-1 text-sm">
						<li>Click the install icon in the address bar</li>
						<li>Click "Install" to confirm</li>
					</ol>
				</div>
			</div>
		</Modal>
	)
}
